/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateSpalteLabelDto } from '../../models/lexplus-update-spalte-label-dto';

export interface KundendokumentSpaltenauswahlControllerUpdateLabelForCustomfieldV1$Params {
  kundendokumentSpaltenlabelID: number;
      body: LexplusUpdateSpalteLabelDto
}

export function kundendokumentSpaltenauswahlControllerUpdateLabelForCustomfieldV1(http: HttpClient, rootUrl: string, params: KundendokumentSpaltenauswahlControllerUpdateLabelForCustomfieldV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, kundendokumentSpaltenauswahlControllerUpdateLabelForCustomfieldV1.PATH, 'patch');
  if (params) {
    rb.path('kundendokumentSpaltenlabelID', params.kundendokumentSpaltenlabelID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

kundendokumentSpaltenauswahlControllerUpdateLabelForCustomfieldV1.PATH = '/v1/kundendokument-spaltenauswahl/update-label-for-customfield/{kundendokumentSpaltenlabelID}';
